export const UNITED_STATES = [
  { id: 1, label: 'AL', value: 'Alabama' },
  { id: 2, label: 'AK', value: 'Alaska' },
  { id: 3, label: 'AZ', value: 'Arizona' },
  { id: 4, label: 'AR', value: 'Arkansas' },
  { id: 5, label: 'CA', value: 'California' },
  { id: 6, label: 'CO', value: 'Colorado' },
  { id: 7, label: 'CT', value: 'Connecticut' },
  { id: 8, label: 'DE', value: 'Delaware' },
  { id: 9, label: 'FL', value: 'Florida' },
  { id: 10, label: 'GA', value: 'Georgia' },
  { id: 11, label: 'HI', value: 'Hawaii' },
  { id: 12, label: 'ID', value: 'Idaho' },
  { id: 13, label: 'IL', value: 'Illinois' },
  { id: 14, label: 'IN', value: 'Indiana' },
  { id: 15, label: 'IA', value: 'Iowa' },
  { id: 16, label: 'KS', value: 'Kansas' },
  { id: 17, label: 'KY', value: 'Kentucky' },
  { id: 18, label: 'LA', value: 'Louisiana' },
  { id: 19, label: 'ME', value: 'Maine' },
  { id: 20, label: 'MD', value: 'Maryland' },
  { id: 21, label: 'MA', value: 'Massachusetts' },
  { id: 22, label: 'MI', value: 'Michigan' },
  { id: 23, label: 'MN', value: 'Minnesota' },
  { id: 24, label: 'MS', value: 'Mississippi' },
  { id: 25, label: 'MO', value: 'Missouri' },
  { id: 26, label: 'MT', value: 'Montana' },
  { id: 27, label: 'NE', value: 'Nebraska' },
  { id: 28, label: 'NV', value: 'Nevada' },
  { id: 29, label: 'NH', value: 'New Hampshire' },
  { id: 30, label: 'NJ', value: 'New Jersey' },
  { id: 31, label: 'NM', value: 'New Mexico' },
  { id: 32, label: 'NY', value: 'New York' },
  { id: 33, label: 'NC', value: 'North Carolina' },
  { id: 34, label: 'ND', value: 'North Dakota' },
  { id: 35, label: 'OH', value: 'Ohio' },
  { id: 36, label: 'OK', value: 'Oklahoma' },
  { id: 37, label: 'OR', value: 'Oregon' },
  { id: 38, label: 'PA', value: 'Pennsylvania' },
  { id: 39, label: 'RI', value: 'Rhode Island' },
  { id: 40, label: 'SC', value: 'South Carolina' },
  { id: 41, label: 'SD', value: 'South Dakota' },
  { id: 42, label: 'TN', value: 'Tennessee' },
  { id: 43, label: 'TX', value: 'Texas' },
  { id: 44, label: 'UT', value: 'Utah' },
  { id: 45, label: 'VT', value: 'Vermont' },
  { id: 46, label: 'VA', value: 'Virginia' },
  { id: 47, label: 'WA', value: 'Washington' },
  { id: 48, label: 'WV', value: 'West Virginia' },
  { id: 49, label: 'WI', value: 'Wisconsin' },
  { id: 50, label: 'WY', value: 'Wyoming' },
];

export const _STATES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  // CA: 1,
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

const STATE_NAME_TO_ABBREVIATION: Record<string, string> = Object.fromEntries(
  Object.entries(_STATES).map(([abbreviation, name]) => [
    name.toUpperCase(),
    abbreviation,
  ])
);

export const toStateAbbreviation = (
  state?: string | { label?: string; value?: string } | null
): string => {
  const raw = typeof state === 'string' ? state : (state?.value ?? state?.label);
  if (!raw) return '';
  const normalized = raw.trim().toUpperCase();
  return normalized.length === 2
    ? normalized
    : (STATE_NAME_TO_ABBREVIATION[normalized] ?? raw);
};
